module.exports = __webpack_public_path__ + "static/media/undp-calibration.9c1374ed.jpg";